module.exports = __webpack_public_path__ + "media/images/athletes/1211-f7686e0c8e587c9014c7e3b5939045bd.png";